export const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "var(--ui-bg)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            border: "2px solid var(--ui-border)",
            borderTop: "2px solid var(--ui-primary)",
            borderRadius: "50%",
            margin: "0 auto",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p
          style={{
            marginTop: "16px",
            color: "var(--ui-text-muted)",
            fontWeight: "500",
          }}
        >
          {message}
        </p>
        <p
          style={{
            marginTop: "8px",
            fontSize: "14px",
            color: "var(--ui-text-faint)",
          }}
        >
          Please wait...
        </p>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
